import { render, staticRenderFns } from "./TPCBill.vue?vue&type=template&id=67e6c656&scoped=true"
import script from "./TPCBill.vue?vue&type=script&lang=js"
export * from "./TPCBill.vue?vue&type=script&lang=js"
import style0 from "./TPCBill.vue?vue&type=style&index=0&id=67e6c656&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6c656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e6c656')) {
      api.createRecord('67e6c656', component.options)
    } else {
      api.reload('67e6c656', component.options)
    }
    module.hot.accept("./TPCBill.vue?vue&type=template&id=67e6c656&scoped=true", function () {
      api.rerender('67e6c656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billManage/billList/components/TPCBill.vue"
export default component.exports